import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { capturePromotionCodeFromLocation } from '../utils/promotionCodeStorage';

const PromotionCodeCapture = ({ allowedPaths, onConsumed }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const nextUrl = capturePromotionCodeFromLocation({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      allowedPaths,
    });

    if (!nextUrl) {
      return;
    }

    onConsumed?.();
    navigate(nextUrl, { replace: true });
  }, [allowedPaths, location.hash, location.pathname, location.search, navigate, onConsumed]);

  return null;
};

export default PromotionCodeCapture;
